/**
 * Parses the url equals condition
 *
 * @param {Boolean} equalsOption - determines to check for a positive or negative condition (e.g. "url equals" or "does not equal")
 * @param {Object} condition - contains the conditions to check for
 *
 * @return {Boolean}
 */
const parseEqualsConditions = (equalsOption, condition) => {
  const url = window.location;

  const { url_selector } = condition;

  try {
    const urlObj = new URL(url_selector);

    return equalsOption
      ? url.origin === urlObj.origin && url.pathname === urlObj.pathname
      : url.origin !== urlObj.origin || url.pathname !== urlObj.pathname;
  } catch (e) {
    console.log(e);
    return false;
  }
};

/**
 * Parses the url contains condition
 *
 * @param {Boolean} containsOption - determines to check for a positive or negative condition (e.g. "contains url" or "does not contain url")
 * @param {Object} condition - contains the conditions to check for
 *
 * @return {Boolean}
 */
const parseContainsConditions = (containsOption, condition) => {
  const url = window.location.toString().toLowerCase();

  const { url_selector } = condition;

  return containsOption
    ? url.includes(url_selector)
    : !url.includes(url_selector);
};

/**
 * Runs the url display engine, passes off work to smaller functions
 *
 * @param {Object} condition - object containing conditions
 *
 * @return {Boolean}
 */
export default (condition) => {
  const { options } = condition;

  switch (options) {
    case "equals":
      return parseEqualsConditions(true, condition);

    case "does not equal":
      return parseEqualsConditions(false, condition);

    case "contains url":
      return parseContainsConditions(true, condition);

    case "does not contain url":
      return parseContainsConditions(false, condition);
  }
};
